/* src/pages/riskslibrary/page-risks-library.component.scss */
:host {
  display: block;
}
/*# sourceMappingURL=page-risks-library.component-HLWU6B5K.css.map */
